<template>
    <div class="password-container">
        <!-- 电脑端样式 -->
        <div v-if="isDesktop" class="desktop-container">
            <div class="content">
                <div class="page-header">
                    <el-button type="text" icon="el-icon-arrow-left" @click="goBack">返回个人中心</el-button>
                    <h2 class="page-title">修改密码</h2>
                </div>
                <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-position="right" label-width="100px">
                    <el-form-item label="旧密码:" prop="password">
                        <el-input v-model="dataForm.password" type="password" auto-complete="off" placeholder="请输入旧密码"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码:" prop="new_password">
                        <el-input v-model="dataForm.new_password" type="password" auto-complete="off" placeholder="请输入新密码"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码:" prop="confirm_password">
                        <el-input v-model="dataForm.confirm_password" type="password" auto-complete="off" placeholder="请再次输入新密码"></el-input>
                    </el-form-item>
                </el-form>
                <div class="footer">
                    <el-button type="primary" @click.native="handleUpdataPw('dataForm')">确认修改</el-button>
                    <el-button @click="goBack">取消</el-button>
                </div>
            </div>
        </div>

        <!-- 手机端样式 -->
        <div v-else class="mobile-container">
            <div class="mobile-header">
                <van-nav-bar title="修改密码" left-text="返回" left-arrow @click-left="goBack" />
            </div>
            <div class="mobile-content">
                <div class="mobile-form">
                    <div class="form-item">
                        <div class="form-label">旧密码</div>
                        <van-field
                            v-model="dataForm.password"
                            type="password"
                            placeholder="请输入旧密码"
                            :rules="[{ required: true, message: '请输入旧密码' }]"
                        />
                    </div>
                    <div class="form-item">
                        <div class="form-label">新密码</div>
                        <van-field
                            v-model="dataForm.new_password"
                            type="password"
                            placeholder="请输入新密码"
                            :rules="[{ required: true, message: '请输入新密码' }]"
                        />
                    </div>
                    <div class="form-item">
                        <div class="form-label">确认密码</div>
                        <van-field
                            v-model="dataForm.confirm_password"
                            type="password"
                            placeholder="请确认新密码"
                            :rules="[
                                { required: true, message: '请再次输入密码' },
                                { validator: checkNewPw, message: '密码不一致' }
                            ]"
                        />
                    </div>
                </div>
                <div class="mobile-footer">
                    <van-button type="default" @click="goBack" block>取消</van-button>
                    <van-button type="primary" @click="handleMobileUpdataPw" block style="margin-top: 10px;">确认修改</van-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {changePassword} from "@/api/mine.js";
import { Toast } from 'vant';

export default{
    name: 'ChangePassword',
    data(){
         var checkNewPw = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请再次输入密码'));
            }
            if (this.dataForm.new_password !== value) {
                return callback(new Error("密码不一致"));
            } else {
                return callback();
            }
        };
        return{
            // 响应式设计变量
            isDesktop: true,
            dataForm: {
              password: '',
              new_password: '',
              confirm_password: ''
            },
            dataFormRules: {
              password: [{
                required: true,
                message: '请输入旧密码',
                trigger: 'blur'
              }],
              new_password: [
                { required: true, message: '请输入新密码', trigger: 'blur' },
                { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' },
                { validator: this.validatePassword, trigger: 'blur' }
              ],
              confirm_password: [{
                required: true,
                validator: checkNewPw,
                trigger: 'blur'
              }]
            }
        }
    },
    mounted(){
        this.checkScreenSize();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy(){
        window.removeEventListener('resize', this.handleResize);
    },
    methods:{
        // 密码复杂度验证（至少包含英文字母和数字）
        validatePassword(rule, value, callback) {
            const letterRegex = /[a-zA-Z]/;
            const numberRegex = /[0-9]/;
            if (!letterRegex.test(value)) {
                callback(new Error('密码必须包含英文字母'));
            } else if (!numberRegex.test(value)) {
                callback(new Error('密码必须包含数字'));
            } else {
                callback();
            }
        },
        // 检查屏幕尺寸
        checkScreenSize() {
            this.isDesktop = window.innerWidth > 768;
        },
        // 处理窗口大小变化
        handleResize() {
            this.checkScreenSize();
        },
        // 返回个人中心
        goBack() {
            this.$router.push('/mine');
        },
        // 电脑端修改密码
        handleUpdataPw(dataForm) {
            this.$refs[dataForm].validate(valid => {
                if (valid) {
                    this.updatePassword();
                } else {
                    return false;
                }
            });
        },
        // 手机端修改密码
        handleMobileUpdataPw() {
            // 简单验证
            if (!this.dataForm.password) {
                Toast('请输入旧密码');
                return;
            }
            if (!this.dataForm.new_password) {
                Toast('请输入新密码');
                return;
            }
            if (this.dataForm.new_password !== this.dataForm.confirm_password) {
                Toast('密码不一致');
                return;
            }
            this.updatePassword();
        },
        // 统一的修改密码方法
        updatePassword() {
            changePassword(this.dataForm).then(res => {
                if (res.code === 200) {
                    if (this.isDesktop) {
                        this.$message({
                            message: "修改成功，请重新登录",
                            type: "success"
                        });
                    } else {
                        Toast("修改成功，请重新登录");
                    }
                    // 清除 Vuex store 中的用户信息
                    this.$store.commit('clearUserInfo');
                    // 清除所有 localStorage
                    localStorage.clear();
                    // 跳转到登录页
                    this.$router.push({name:'login'});
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
/* 基础样式 */
.password-container {
    width: 100%;
    min-height: 100vh;
    background-color: #f5f7fa;
    padding: 20px;
    box-sizing: border-box;
}

/* 电脑端样式 */
.desktop-container {
    max-width: 500px;
    margin: 50px auto;
}

.desktop-container .content {
    background-color: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.page-header {
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #ebeef5;
}

.page-title {
    margin: 15px 0 0 0;
    font-size: 20px;
    font-weight: 600;
    color: #303133;
}

.desktop-container .footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    gap: 10px;
}

/* 手机端样式 */
.mobile-container {
    width: 100%;
    padding: 0;
    background-color: #f5f7fa;
}

.mobile-header {
    margin-bottom: 10px;
}

.mobile-content {
    background-color: white;
    border-radius: 12px;
    padding: 20px;
    margin: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.mobile-form {
    margin-bottom: 20px;
}

.form-item {
    margin-bottom: 20px;
}

.form-label {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    margin-bottom: 8px;
    display: block;
}

.mobile-footer {
    margin-top: 20px;
}

/* 响应式调整 */
@media (max-width: 768px) {
    .password-container {
        padding: 0;
    }
    
    .mobile-content {
        padding: 15px;
    }
}

@media (min-width: 769px) {
    .desktop-container .content {
        padding: 30px;
    }
}
</style>
